export const getDate = (s) => {
    return s.replaceAll("-", "/").split('/').reverse().join('/')
}